import { t } from 'utils/i18n';

export const taskTypes = [
  { value: 1, id: 1, name: t('meeting'), label: t('meeting') },
  { value: 2, id: 2, name: t('task'), label: t('task') },
];

export const taskFilterTypes = [
  { id: 1, name: t('meeting') },
  { id: 2, name: t('task') },
];

export const taskPriorities = [
  {
    id: 1,
    name: t('low'),
    value: 'low',
    label: t('low'),
  },
  {
    id: 2,
    value: 'high',
    name: t('high'),
    label: t('high'),
  },
];

export const taskStatuses = [
  {
    id: 'opened',
    name: t('opened'),
  },
  {
    id: 'completed',
    name: t('completed'),
  },
  {
    id: 'closed',
    name: t('closed'),
  },
];

export const taskSections = {
  opened: t('openedTasks'),
  closed: t('closedTasks'),
  completed: t('completedTasks'),
  overdue: t('overdueTasks'),
  today: t('today'),
  upcoming: t('upcoming'),
};

export const taskPeriods = [
  {
    id: 'lastMonth',
    name: t('lastMonth'),
  },
  {
    id: 'threeDays',
    name: t('threeDays'),
  },
  {
    id: 'week',
    name: t('overWeek'),
  },
  {
    id: 'month',
    name: t('overMonth'),
  },
  {
    id: 'custom',
    name: t('overPeriod'),
  },
];

export const MAX_LENGTH_MESSAGE = 220;
